import React, { useEffect } from "react";
import { MapContainer, TileLayer, Marker, Popup, useMap } from "react-leaflet";
import L from "leaflet";

// ===== Pin "perdu" : goutte orange (sans icône, juste un point blanc) =====
const lostIcon = L.divIcon({
  className: "",
  html: `<div style="filter: drop-shadow(0 4px 8px rgba(249,115,22,.45));">
    <svg width="38" height="46" viewBox="0 0 38 46" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 46c-6-6-15-13-15-24a15 15 0 1 1 30 0c0 11-9 18-15 24z" fill="#f97316"/>
      <circle cx="19" cy="17" r="4.5" fill="#ffffff"/>
    </svg>
  </div>`,
  iconSize: [38, 46],
  iconAnchor: [19, 46],
});

// ===== Pin "trouvé" : goutte rose (sans icône, juste un point blanc) =====
const foundIcon = L.divIcon({
  className: "",
  html: `<div style="filter: drop-shadow(0 4px 8px rgba(244,63,94,.45));">
    <svg width="38" height="46" viewBox="0 0 38 46" xmlns="http://www.w3.org/2000/svg">
      <path d="M19 46c-6-6-15-13-15-24a15 15 0 1 1 30 0c0 11-9 18-15 24z" fill="#f43f5e"/>
      <circle cx="19" cy="17" r="4.5" fill="#ffffff"/>
    </svg>
  </div>`,
  iconSize: [38, 46],
  iconAnchor: [19, 46],
});

function FitBounds({ markers }) {
  const map = useMap();
  useEffect(() => {
    if (!markers || markers.length === 0) return;
    if (markers.length === 1) {
      map.setView([markers[0].lat, markers[0].lng], 11);
      return;
    }
    const bounds = L.latLngBounds(markers.map((m) => [m.lat, m.lng]));
    map.fitBounds(bounds, { padding: [50, 50], maxZoom: 11 });
  }, [markers, map]);
  return null;
}

export default function MapOverview({ items = [], height = 480 }) {
  // items: [{ id, lat, lng, type: 'lost'|'found', title, subtitle, link }]
  return (
    <div className="rounded-3xl overflow-hidden border-4 border-white shadow-[0_8px_30px_rgba(244,63,94,0.12)]" data-testid="map-overview">
      <MapContainer
        center={[46.6, 2.5]}
        zoom={5}
        style={{ height: `${height}px`, width: "100%" }}
        scrollWheelZoom={true}
      >
        <TileLayer
          attribution='&copy; OpenStreetMap'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        {items.map((m) => (
          <Marker
            key={m.id}
            position={[m.lat, m.lng]}
            icon={m.type === "lost" ? lostIcon : foundIcon}
          >
            <Popup>
              <div style={{ minWidth: 200, maxWidth: 220 }}>
                {m.photo && (
                  <div
                    className="rounded-xl overflow-hidden mb-2"
                    style={{ width: "100%", height: 110, background: "#fff1f2" }}
                  >
                    <img
                      src={m.photo}
                      alt={m.title || "doudou"}
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  </div>
                )}
                <div className="text-xs font-bold uppercase mb-1" style={{ color: m.type === "lost" ? "#c2410c" : "#be123c" }}>
                  {m.type === "lost" ? "Doudou perdu" : "Doudou trouvé"}
                </div>
                <div className="font-bold text-stone-800">{m.title}</div>
                {m.subtitle && <div className="text-stone-500 text-xs mt-1">{m.subtitle}</div>}
                {m.link ? (
                  <a
                    href={m.link}
                    className="inline-block mt-2 px-3 py-1.5 rounded-full bg-orange-500 text-white font-bold text-xs"
                    style={{ textDecoration: "none" }}
                    data-testid={`map-popup-link-${m.id}`}
                  >
                    Voir la fiche →
                  </a>
                ) : m.type === "found" ? (
                  <a
                    href="/inscription"
                    className="inline-block mt-2 px-3 py-1.5 rounded-full bg-rose-500 text-white font-bold text-xs"
                    style={{ textDecoration: "none" }}
                    data-testid={`map-popup-register-${m.id}`}
                  >
                    Inscription gratuite pour contacter →
                  </a>
                ) : null}
              </div>
            </Popup>
          </Marker>
        ))}
        <FitBounds markers={items} />
      </MapContainer>
      <div className="bg-rose-50/70 text-xs text-stone-600 px-4 py-2 flex items-center gap-5 flex-wrap">
        <span className="flex items-center gap-2">
          <span className="inline-block w-3 h-3 rounded-full bg-orange-500"></span> Doudou perdu
        </span>
        <span className="flex items-center gap-2">
          <span className="inline-block w-3 h-3 rounded-full bg-rose-500"></span> Doudou trouvé
        </span>
      </div>
    </div>
  );
}
